import { hotelCategoryService } from "../../jwt/_services/hotel/hotelCategoryService";
import {
    setItems,
    setTableInfo,
    removeItem ,
    addItem,
    changeListItem
} from "./filterActions";
import {
    changeLoadingState,
    setDataToEdit,
    setEnabledForm,
} from "./genericActions";

export const searchCategory= (page, currentIndex, sizePerPage, _dataFilters) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    hotelCategoryService.search(currentIndex, sizePerPage, _dataFilters)
        .then(result => {
            if (!result)
                return

            const tableInfo = {
                page,
                sizePerPage,
                currentIndex,
                totalSize: result?.total
            }

            dispatch(setItems(result.data))
            dispatch(setTableInfo(tableInfo))
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const saveCategory = data => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    hotelCategoryService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch( setDataToEdit(result) )
            dispatch( setEnabledForm(false) )
            dispatch( addItem(result) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const updateCategory = (id, data) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    hotelCategoryService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setDataToEdit(result) )
            dispatch( setEnabledForm(false) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}

export const deleteCategory = (id, fbDb) => ( dispatch ) => {
    dispatch(changeLoadingState(true))

    hotelCategoryService.deleteItem(id, fbDb)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => dispatch(changeLoadingState(false)))
}